(function () {
  'use strict';

  var hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desktopMq = window.matchMedia('(min-width: 1200px)');

  function scrollState(root) {
    var scrolled = false;
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var next = scrolled ? y > 6 : y > 32;
      if (next !== scrolled) {
        scrolled = next;
        root.classList.toggle('is-scrolled', scrolled);
      }
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  function dropdowns(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ma-dd]'));
    if (!items.length) return;

    function isOpen(item) {
      return item.classList.contains('is-open');
    }

    function close(item, refocus) {
      clearTimeout(item._timer);
      item.classList.remove('is-open');
      item._link.setAttribute('aria-expanded', 'false');
      if (refocus) {
        item._skipFocus = true;
        item._link.focus();
        setTimeout(function () {
          item._skipFocus = false;
        }, 0);
      }
    }

    function closeAll(except) {
      items.forEach(function (other) {
        if (other !== except && isOpen(other)) close(other);
      });
    }

    function open(item) {
      closeAll(item);
      clearTimeout(item._timer);
      item.classList.add('is-open');
      item._link.setAttribute('aria-expanded', 'true');
    }

    function links(item) {
      return Array.prototype.slice.call(item._panel.querySelectorAll('a[href]'));
    }

    items.forEach(function (item) {
      item._link = item.querySelector('.ma-nav__link');
      item._panel = item.querySelector('.ma-dd');
      if (!item._link || !item._panel) return;

      item.addEventListener('mouseenter', function () {
        if (!hoverMq.matches) return;
        clearTimeout(item._timer);
        item._timer = setTimeout(function () {
          open(item);
        }, 70);
      });

      item.addEventListener('mouseleave', function () {
        if (!hoverMq.matches) return;
        clearTimeout(item._timer);
        item._timer = setTimeout(function () {
          close(item);
        }, 160);
      });

      item._link.addEventListener('click', function (event) {
        if (!hoverMq.matches && !isOpen(item)) {
          event.preventDefault();
          open(item);
        }
      });

      item._link.addEventListener('focus', function () {
        if (item._skipFocus) {
          item._skipFocus = false;
          return;
        }
        if (item._link.matches(':focus-visible')) open(item);
      });

      item._link.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          open(item);
          var first = links(item)[0];
          if (first) first.focus();
        } else if (event.key === 'Escape' && isOpen(item)) {
          close(item);
        }
      });

      item._panel.addEventListener('keydown', function (event) {
        var list = links(item);
        var index = list.indexOf(document.activeElement);
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          list[Math.min(index + 1, list.length - 1)].focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (index <= 0) item._link.focus();
          else list[index - 1].focus();
        } else if (event.key === 'Home') {
          event.preventDefault();
          list[0].focus();
        } else if (event.key === 'End') {
          event.preventDefault();
          list[list.length - 1].focus();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          close(item, true);
        }
      });

      item.addEventListener('focusout', function (event) {
        if (!event.relatedTarget || !item.contains(event.relatedTarget)) close(item);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      items.forEach(function (item) {
        if (isOpen(item)) close(item, item.contains(document.activeElement));
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-ma-dd]')) closeAll();
    });

    window.addEventListener(
      'scroll',
      function () {
        if (!hoverMq.matches) closeAll();
      },
      { passive: true }
    );
  }

  function fit(root) {
    var nav = root.querySelector('.ma-nav');
    var list = root.querySelector('.ma-nav__list');
    if (!nav || !list) return;
    var raf = 0;

    function overflows() {
      var last = list.lastElementChild;
      return !!last && last.getBoundingClientRect().right > nav.getBoundingClientRect().right + 0.5;
    }

    function measure() {
      root.classList.remove('ma-hdr--drawer');
      root.classList.remove('ma-hdr--nohome');
      if (!desktopMq.matches) return;
      if (!overflows()) return;
      // Étape 1 : masquer le lien « Accueil » (le logo y mène déjà) avant de replier tout le menu.
      if (list.querySelector('.ma-nav__item--home')) {
        root.classList.add('ma-hdr--nohome');
        if (!overflows()) return;
      }
      root.classList.remove('ma-hdr--nohome');
      root.classList.add('ma-hdr--drawer');
    }

    function schedule() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(measure);
    }

    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    measure();
  }

  function search(root) {
    var panel = root.querySelector('.ma-search');
    if (!panel) return;
    var input = panel.querySelector('input[type="search"]');
    if (!input) return;
    var sync = function () {
      panel.classList.toggle('has-query', input.value.trim().length > 0);
    };
    input.addEventListener('input', sync);
    panel.addEventListener('reset', function () {
      setTimeout(sync, 0);
    });
    sync();
  }

  function init() {
    var root = document.querySelector('.ma-hdr');
    if (!root || root.__maReady) return;
    root.__maReady = true;
    scrollState(root);
    dropdowns(root);
    fit(root);
    search(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
